export enum UserType {
     PowerUser = 'PowerUser',
     BillingUser = 'BillingUser',
     StandardUser = 'StandardUser'
}
